import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../../hook/useAppSelector';
import { FilterType } from '../../../../enum/FilterType';
import HeaderFiltersSetup from './HeaderFilterSetup';
import CashRegisterFiltersSetup from './CashRegisterFilterSetup';

const FiltersSetup = () => {
  const filterType = useAppSelector((state) => state.globalFilters.filterType);
  const isSidebarMinimized = useAppSelector((state) => state.configSlice.isSidebarMinimized);
  const [showFilters, setShowFilters] = useState(filterType === FilterType.CASH_REGISTER_FILTERS);

  useEffect(() => {
    setShowFilters(filterType === FilterType.CASH_REGISTER_FILTERS);
  }, [filterType]);

  const content = (
    <>
      {filterType === FilterType.NORMAL ? (
        <HeaderFiltersSetup />
      ) : (
        <CashRegisterFiltersSetup setShowFilters={setShowFilters} />
      )}
    </>
  );

  return (
    <>
      <div
        className={`cash_register_wrapper ${isSidebarMinimized ? 'minimized' : ''} ${filterType === FilterType.CASH_REGISTER_FILTERS && showFilters && 'show_filters'}`}
      ></div>
      {content}
    </>
  );
};

export default FiltersSetup;
